export default function parseQueryString(search = '') {
  return search
    .replace('?', '')
    .split('&')
    .reduce((params, term) => {
      const parts = term.split('=');

      if (!parts[0]) {
        return params;
      }

      if (parts.length === 1) {
        params[parts[0]] = true;
        return params;
      }

      if (parts[1] && ['true', 'false'].indexOf(parts[1]) !== -1) {
        parts[1] = parts[1] === 'true';
      } else if (parts[1] && parts[1].indexOf('%7B') !== -1) {
        try {
          parts[1] = JSON.parse(decodeURIComponent(parts[1]));
        } catch (error) {}
      }

      if (typeof parts[1] === 'string') {
        parts[1] = decodeURIComponent(parts[1]);
      }

      params[parts[0]]
        ? (params[parts[0]] = [].concat(params[parts[0]], parts[1]))
        : (params[parts[0]] = parts[1]);

      return params;
    }, {});
}
